<div class="section">
    <div class="nova__label">Facility Type</div>
    <div data-qa-id="facility_type">{{ facilityProfileDetails?.facilityTypeName | nullDash }}</div>

    <div class="nova__label">Facility</div>
    <div>
        <div [ngClass]="{'sub-section': job?.facilityWebsite}">
            <a data-qa-id="facility_name" class="nova__link" target="_blank"
                routerLink="/recruiting/facilities/{{job.facilityId}}">
                {{ job?.facilityName | nullDash }}
            </a>
        </div>
        <div *ngIf="job?.facilityWebsite" class="sub-section">
            <a data-qa-id="facility_website" class="nova__link" target="_blank"
                [href]="job?.facilityWebsite">Website</a>
        </div>
        <div data-qa-id="external-facility-name">
            <span class="external-info" *ngIf="displayConfigData?.hideFacilityName"><span
                    class="material-icons">info</span>hidden externally</span>
            <span class="external-info"
                *ngIf="!displayConfigData?.hideFacilityName && (displayConfigData?.facilityName !== '' && displayConfigData?.facilityName !== null)">
                <span class="material-icons">info</span>Displays as "{{displayConfigData?.facilityName}}"
            </span>
        </div>
    </div>

    <div class="nova__label">Trauma Level</div>
    <div data-qa-id="facility_trauma_level">{{ traumaLevel | nullDash }}</div>

    <div class="nova__label">Address</div>
    <div data-qa-id="facility_address">
        <div class="sub-section">
            <span data-qa-id="facility_street_address">{{ job?.facilityAddress | nullDash }}</span><br />
            <span data-qa-id="facility_city">{{ job?.city }}</span>
            <ng-container *ngIf="job?.city && job?.stateName">, </ng-container>
            <span data-qa-id="facility_state">{{ job?.stateName }}</span><br />
            <ng-container *ngIf="!job?.city && !job?.stateName">-</ng-container>
        </div>
        <div data-qa-id="external-location-name" [ngClass]="{'sub-section-large': job?.googlemapssearcher}">
            <span class="external-info" *ngIf="displayConfigData?.hideLocationName"><span
                    class="material-icons">info</span>hidden externally</span>
            <span class="external-info"
                *ngIf="!displayConfigData?.hideLocationName && (displayConfigData?.locationName !== '' && displayConfigData?.locationName !== null)">
                <span class="material-icons">info</span>Displays as "{{displayConfigData?.locationName}}"
            </span>
        </div>
        <ng-container *ngIf="job?.googlemapssearcher">
            <div *ngIf="!showMap" data-qa-id="show_map">
                <span class="action" (click)="showMap = !showMap">Show map</span>
                <span class="material-symbols-outlined">expand_more</span>
            </div>
            <div class="sub-section" *ngIf="showMap" data-qa-id="hide_map">
                <span class="action" (click)="showMap = !showMap">Hide map</span>
                <span class="material-symbols-outlined">expand_less</span>
            </div>
            <div [ngClass]="{'show-map': showMap}" class="map-container" data-qa-id="facility_map">
                <iframe *ngIf="showMap" #frm title="map" style="border: 0; width: 100%; height: 500px"
                    [src]="job.googlemapssearcher | safedom: 'resourceUrl'">
                </iframe>
            </div>
        </ng-container>
    </div>

    <div class="nova__label">VMS Provider</div>
    <div data-qa-id="facility_vms_provider">{{ job?.vmsProvider | nullDash }}</div>
</div>